import React from "react";
import { ListGroup, ListGroupItem, Form, FormInput, FormGroup, Button, Row, Col, Card } from "shards-react";
import Styles from "../componentStyles/styles.module.css";


const FormUnidadCuotas = ({ unidadCuotas, saveUnidadCuotas, setField, cancelFormData }) => {
    console.log('Render form unidadCuotas')
    
    return (
        <div style={{ marginTop: 25 }}>
            <Col className="main-content-container px-4 pb-4">
                <Card className="mb-4">
                    <ListGroup >
                        <ListGroupItem>
                            <Row>
                                <Col>
                                    <Form>
                                        <FormGroup>
                                            <label htmlFor="nroCuota">N° Cuota</label>
                                            <FormInput
                                                id="nroCuota"
                                                placeholder="Número de cuota..."
                                                value={unidadCuotas.nroCuota}
                                                onChange={(newValue) => setField('nroCuota', newValue.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <label htmlFor="valorCuota">Valor</label>
                                            <FormInput
                                                id="valorCuota"
                                                placeholder="Valor..."
                                                value={unidadCuotas.valorCuota}
                                                onChange={(newValue) => setField('valorCuota', newValue.target.value)}
                                            />
                                        </FormGroup>

                                   {/*     <FormGroup>
                                            <label htmlFor="interesCuota">Interés</label>
                                            <FormInput
                                                id="interesCuota"
                                                placeholder="Interes..."
                                                value={unidadCuotas.interesCuota}
                                                onChange={(newValue) => setField('interesCuota', newValue.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <label htmlFor="desdeCuota">Desde</label>
                                            <FormInput
                                                id="desdeCuota"
                                                placeholder="Cuota desde..."
                                                value={unidadCuotas.desdeCuota}
                                                onChange={(newValue) => setField('desdeCuota', newValue.target.value)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <label htmlFor="hastaCuota">Hasta</label>
                                            <FormInput
                                                id="hastaCuota"
                                                placeholder="Cuota Hasta..."
                                                value={unidadCuotas.hastaCuota}
                                                onChange={(newValue) => setField('hastaCuota', newValue.target.value)}
                                            />
                                        </FormGroup> */}
                                        <Row>
                                            <Col>
                                                <Button
                                                    type="button"
                                                    theme="outline-secondary"
                                                    onClick={() => cancelFormData()}
                                                >
                                                    Volver
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Button
                                                    className={Styles.buttonForm}
                                                    type="button"
                                                    theme="primary"
                                                    onClick={() => saveUnidadCuotas()}
                                                >
                                                    Cargar
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </ListGroupItem>
                    </ListGroup>
                </Card>
            </Col>
        </div>

    );
}


export default FormUnidadCuotas;